import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/videoes/list", params, successCallback, failCallback, exceptionCallback);
	},

	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/videoes/toUpdate", params, successCallback, failCallback, exceptionCallback);
	} ,downCodes:(data, params, headers) => {

		ApiUtils.sendDownFile(
		    constant.serverUrl + "/edu/videoes/downloadCodes",
		    "get",
		    data,
		    params,
		    headers
		  );
	  },
}

export default api;
